import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import {
  getIdwellToIdwellUploadProps,
  useDocumentsUploadFile,
} from '../../../../Document'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileUploadFileAction() {
  const {
    handleCloseModal,
    handleReloadAfterChange,
    outboundUuid,
    requestData,
    setModal,
  } = useRequestProfileContext()

  async function handleReloadAfterUpload() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.documents)
  }

  const { getUploadFileInputProps, handleClickUploadFile } =
    useDocumentsUploadFile({
      ...getIdwellToIdwellUploadProps(outboundUuid),
      outboundUuid,
      parent: requestData?.directory_id?.toString(),
      onCloseModal: handleCloseModal,
      onReload: handleReloadAfterUpload,
      onSetModal: setModal,
    })

  return {
    getUploadFileInputProps,
    handleClickUploadFile,
  }
}
